var _path, _circle, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCouples(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 52,
    fill: "none",
    viewBox: "0 0 50 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.2998 18.9043C28.9769 18.9043 27.1393 20.8708 27.2966 23.1883L29.012 48.4633H47.0676L48.783 23.1883C48.9403 20.8708 47.1028 18.9043 44.7799 18.9043L41.5506 18.9043L38.7924 22.7523C38.423 23.2676 37.6566 23.2676 37.2872 22.7523L34.529 18.9043L31.2998 18.9043Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.04,
    cy: 8.873,
    r: 7.022,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.2409 20.9104C2.91018 20.9104 1.06989 22.8896 1.23914 25.2141L2.93195 48.4632H20.9875L22.6803 25.2141C22.8496 22.8896 21.0093 20.9104 18.6786 20.9104H5.2409Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.8538 4.86108C14.8595 4.86108 17.3467 7.25366 17.6349 10.4216C17.8173 12.3319 18.5471 14.2706 19.8244 16.1714C19.9876 16.4078 20.026 16.7104 19.9395 16.9846C19.8436 17.2588 19.6321 17.4763 19.3536 17.5804C16.8858 18.4599 14.3889 18.9043 11.9305 18.9043C9.47229 18.9043 6.99463 18.4599 4.56503 17.5804C4.29611 17.4858 4.09449 17.2778 3.9986 17.0129C3.89286 16.7481 3.9217 16.4645 4.06565 16.2186C5.18913 14.28 5.86154 12.3224 6.07277 10.4027C6.40874 7.2442 8.89601 4.86108 11.8538 4.86108Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    stroke: "#404040",
    strokeWidth: 2.006,
    d: "M24.9996 31.8413C22.468 29.2957 18.3779 29.304 15.8564 31.8661C13.3355 34.4276 13.3354 38.5742 15.8563 41.1357C15.8563 41.1357 15.8563 41.1357 15.8564 41.1358L24.2837 49.7005L24.9986 50.4271L25.7136 49.7006L34.1429 41.1358C36.6638 38.5743 36.6638 34.4276 34.1429 31.8661C31.6213 29.304 27.5313 29.2957 24.9996 31.8413Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouples);
export default __webpack_public_path__ + "static/media/couples.f237d4932ef770eea97ed00a341f5bb0.svg";
export { ForwardRef as ReactComponent };